<template>
  <div class="page-content">
    <div class="contenter">
        <property-service ref="propertyService" typeIndex="2"></property-service>
    </div>
  </div>
</template>

<script>
import propertyService from './propertyService.vue'
export default {
  name: 'alarmForCompanyLessee',
  components: {
    propertyService
  },
  data () {
    return {
    }
  },
  created () {},
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: #333;
  padding: 16px;
  .contenter {
    width: 100%;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
    background-color: #fff;
  }
}

.el-tabs {
  height: 100%;
  ::v-deep .el-tabs__content{
    height: calc(100% - 60px);
  }
  .el-tab-pane {
    height: 100%;
  }
}
</style>
